var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},[_c('div',[_vm._v(_vm._s(_vm.$t('components.login_bridge.tpl.authenticating'))+"...")]),(_vm.loginDone)?_c('div',[_vm._v(_vm._s(_vm.$t('components.login_bridge.tpl.loading'))+"...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }